import styled from "styled-components";
import { AiTwotonePhone } from "react-icons/ai";
import { FaGlobe } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { ClipboardCopier } from "components/clipboardCopier";

const StyledFooter = styled.footer`
  border-top: 1px solid rgba(220, 226, 230, 0.1);
  background: #080f17;
`;

const StyledInner = styled.div`
  --scroller-clearance: max(47px, calc(env(safe-area-inset-right, 0px) + 23px));

  width: min(calc(100% - 102px), 1420px);
  min-height: 126px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 28px;
  margin: 0 auto;
  padding: 30px var(--scroller-clearance) 30px 0;

  @media (max-width: 760px) {
    min-height: 0;
    flex-direction: column;
    align-items: flex-start;
  }

  @media (max-width: 479px) {
    --scroller-clearance: max(
      37px,
      calc(env(safe-area-inset-right, 0px) + 23px)
    );
  }
`;

const StyledContacts = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px 24px;
`;

const StyledContact = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #aeb9c1;
  font-family: Roboto-Regular;
  font-size: 13px;
  cursor: pointer;
  transition: color 150ms ease;

  &:hover {
    color: #f0ece5;
  }
`;

const StyledCopyright = styled.small`
  color: #788792;
  font-family: Roboto-Regular;
  font-size: 12px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
`;

export const Footer = () => (
  <StyledFooter>
    <StyledInner>
      <StyledContacts>
        <ClipboardCopier text="1/E Bogdan Voievod, Chișinău, Moldova">
          <StyledContact>
            <FaGlobe /> 1/E Bogdan Voievod, Chișinău, Moldova
          </StyledContact>
        </ClipboardCopier>
        <ClipboardCopier text="+37379205975">
          <StyledContact>
            <AiTwotonePhone /> +(373) 79 205 975
          </StyledContact>
        </ClipboardCopier>
        <ClipboardCopier text="we@essencebit.net">
          <StyledContact>
            <MdEmail /> we@essencebit.net
          </StyledContact>
        </ClipboardCopier>
      </StyledContacts>
      <StyledCopyright>© {new Date().getFullYear()} Essencebit</StyledCopyright>
    </StyledInner>
  </StyledFooter>
);
